import { Modal, Button, Form } from "react-bootstrap";
import { useState } from "react";
import http from "../lib/http";

export default function ReviewModal({
  show,
  onClose,
  dealerId,
  onSuccess
}) {

  const [name, setName] = useState("");
  const [rating, setRating] = useState(5);
  const [comment, setComment] = useState("");
  const [loading, setLoading] = useState(false);

  const submitReview = async () => {

    if (!name || !comment) {
      alert("Please fill all fields");
      return;
    }

    try {

      setLoading(true);

      await http.post(
        `/api/dealers/${dealerId}/reviews`,
        {
          name,
          rating,
          comment
        }
      );

      alert(
        "Review submitted successfully and awaiting approval."
      );

      setName("");
      setRating(5);
      setComment("");

      onSuccess();

    } catch (err) {

      console.error(err);

      alert("Failed to submit review");

    } finally {

      setLoading(false);

    }

  };

  return (
    <Modal show={show} onHide={onClose} centered>

      <Modal.Header closeButton>
        <Modal.Title>Add Review</Modal.Title>
      </Modal.Header>

      <Modal.Body>

        <Form.Group className="mb-3">
          <Form.Label>Your Name</Form.Label>

          <Form.Control
            value={name}
            onChange={(e) =>
              setName(e.target.value)
            }
          />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>Rating</Form.Label>

          <Form.Select
            value={rating}
            onChange={(e) =>
              setRating(e.target.value)
            }
          >
            <option value="5">⭐⭐⭐⭐⭐</option>
            <option value="4">⭐⭐⭐⭐</option>
            <option value="3">⭐⭐⭐</option>
            <option value="2">⭐⭐</option>
            <option value="1">⭐</option>
          </Form.Select>
        </Form.Group>

        <Form.Group>
          <Form.Label>Comment</Form.Label>

          <Form.Control
            as="textarea"
            rows={3}
            value={comment}
            onChange={(e) =>
              setComment(e.target.value)
            }
          />
        </Form.Group>

      </Modal.Body>

      <Modal.Footer>

        <Button
          variant="secondary"
          onClick={onClose}
        >
          Cancel
        </Button>

        <Button
          variant="primary"
          onClick={submitReview}
          disabled={loading}
        >
          {
            loading
              ? "Submitting..."
              : "Submit Review"
          }
        </Button>

      </Modal.Footer>

    </Modal>
  );
}